import { useCallback } from 'react';

import { useAuthContext } from './useAuthContext';

/*
  Wraps window.HudLauncher.open with the current auth token so HUD can
  authenticate via message-passing.
*/
export function useHudLauncher() {
  const { token } = useAuthContext();

  return useCallback(
    (url, options = {}) => {
      if (!window.HudLauncher?.open) return null;

      return window.HudLauncher.open(url, {
        ...options,
        getToken: async () => token,
        parentOrigin: window.SHELL_APP_URL,
      });
    },
    [token],
  );
}
